"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/stable/promise");
require("whatwg-fetch");
const ready = (fn) => {
    if (typeof fn !== 'function')
        return;
    if (document.readyState === 'complete') {
        return fn();
    }
    document.addEventListener('DOMContentLoaded', fn, false);
};
ready(() => {
    (async () => {
        try {
            const response = await (await fetch(cartCountUrl)).json();
            if (response.result === 'OK') {
                const count = Number(response.count);
                const el = document.getElementById("cartCount");
                if (count) {
                    el.classList.remove("label-default");
                    el.classList.add("label-danger");
                }
                else {
                    el.classList.remove("label-danger");
                    el.classList.add("label-default");
                }
                el.textContent = count.toString();
            }
            else {
                console.error(response);
            }
        }
        catch (err) {
            console.error(err);
        }
    })();
    async function requestCart() {
        const formData = new FormData();
        formData.append(csrfParam, csrfToken);
        try {
            const rawResponse = await fetch(showCartUrl, {
                method: 'POST',
                headers: new Headers({ 'X-Is-Ajax-Request': 'True' }),
                body: formData
            });
            const content = await rawResponse.text();
            document.getElementById("carttable").innerHTML = content;
            document.getElementById('cartloader').style.display = 'none';
            const count = Number(document.querySelector('[data-cartcount]').getAttribute('data-cartcount'));
            if (count) {
                document.getElementById("btCheckout").removeAttribute("disabled");
                document.querySelectorAll('.cart-inc, .cart-dec, .cart-del').forEach((item) => {
                    item.addEventListener('click', async (event) => {
                        event.preventDefault();
                        try {
                            const rawResponse = await fetch(item.getAttribute("href"), {
                                headers: new Headers({ 'X-Is-Ajax-Request': 'True' })
                            });
                            const response = await rawResponse.json();
                            if (response.result === 'OK')
                                requestCart();
                            else
                                console.error(response);
                        }
                        catch (err) {
                            console.error(err);
                        }
                    });
                });
            }
            else {
                document.getElementById("btCheckout").setAttribute("disabled", "disabled");
                const el = document.getElementById("cartCount");
                el.classList.remove("label-danger");
                el.classList.add("label-default");
                el.textContent = count.toString();
            }
        }
        catch (err) {
            console.error(err);
            alert('Виникла помилка!');
        }
    }
    const btShowCart = document.getElementById("btShowCart");
    btShowCart.setAttribute('href', '#');
    btShowCart.addEventListener('click', async (event) => {
        event.preventDefault();
        if (document.querySelector('[name=checkout-page]'))
            event.stopPropagation();
        else
            await requestCart();
    });
    const btCheckout = document.getElementById("btCheckout");
    btCheckout.addEventListener('click', () => {
        history.pushState({}, "", window.location.href);
        window.location.replace(cartIndexUrl);
    });
});
